import React, { useCallback } from 'react'

import { Box } from '@mui/material';
import { EnhancedButtonPrimeReact } from '@websential/cosmic-v20';

interface ISelectAllOrRemoveAllProvinces {
    formMethods: any;
    provinceDDL: any;
}
export const SelectAllOrRemoveAllProvinces: React.FC<ISelectAllOrRemoveAllProvinces> = ({ formMethods, provinceDDL }) => {
    const onSelectAllChangeHandler = useCallback(() => {
        const allProvincesValues = provinceDDL.map((x: any) => x.value)
        formMethods.setValue('province', allProvincesValues)
    }, [provinceDDL])

    const onRemoveAllChangeHandler = () => {
        formMethods.setValue('province', undefined)
    }
    return (
        <Box sx={{ "& .enhanced-button": { padding: "0.1rem .5rem !important" }, textAlign: "end" }}>
            <EnhancedButtonPrimeReact label="Select All" onClickHandler={onSelectAllChangeHandler} />
            <EnhancedButtonPrimeReact label="Remove All" style={{ marginLeft: ".5rem" }} onClickHandler={onRemoveAllChangeHandler} />
        </Box>
    )
}

